module.exports = __webpack_public_path__ + "static/media/youtube (1).19b1d0ec.svg";